import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom'
import Router from './Router/Router'
import { Provider } from 'react-redux'
import './index.scss';
import Store from './Store/Store';
import ReactQuery from './Apis/ReactQuery';

/**
 * test、huidu import vconsole
 */
if (process.env.REACT_APP_ENV !== 'production') {
  import('vconsole').then(
    res => {
      new res.default();
    }
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={ Store }>
		<ReactQuery>
			<RouterProvider router={ Router } />
		</ReactQuery>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
